import STATE_NAME_TO_CODE from "../assets/state_name_to_code.js";

export const getCurrentLocationCityState = () =>
  new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error("Geolocation is not supported by your browser"));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        try {
          const { latitude, longitude } = position.coords;
          const response = await fetch(
            `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&addressdetails=1`,
          );
          if (!response.ok) {
            throw new Error("Failed to get location details");
          }
          const data = await response.json();
          const address = data.address;
          let stateCode = address.state_code || "";
          if (!stateCode && address.state && STATE_NAME_TO_CODE[address.state]) {
            stateCode = STATE_NAME_TO_CODE[address.state];
          }

          resolve({
            city: address.city || address.town || address.village || "",
            state: stateCode,
          });
        } catch (error) {
          reject(error);
        }
      },
      (error) => {
        reject(error);
      },
    );
  });

